import { onMounted, ref } from 'vue';

declare global {
    interface Window {
        paytrace: {
            setKey(publicKeyPem: string): void;
            encryptValue(data: string): string;
        };
    }
}

export function usePaytraceEncryption() {
    const isReady = ref(false);
    const error = ref<string | null>(null);

    onMounted(async () => {
        try {
            const response = await fetch(
                'https://api.erpbucket.com/web/paytrace',
            );
            const pem = await response.text();
            window.paytrace.setKey(pem);
            isReady.value = true;
        } catch (e) {
            error.value =
                'Failed to initialize payment encryption. Please refresh the page.';
            console.error('PayTrace E2EE key fetch failed:', e);
        }
    });

    function encryptValue(plaintext: string): string {
        if (!isReady.value) {
            throw new Error('PayTrace encryption is not ready');
        }

        return window.paytrace.encryptValue(plaintext);
    }

    return {
        isReady,
        error,
        encryptValue,
    };
}
